var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!this.isAuthenticated2)?_c('Login',{on:{"loginComplete":_vm.updateUser}}):_vm._e(),(this.isAuthenticated2 !== false && this.user !== null)?_c('NavBar'):_vm._e(),(this.isAuthenticated2 !== false && this.user !== null)?_c('DealerForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }